import { CdkScrollable } from '@angular/cdk/scrolling';
import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { MatDivider } from '@angular/material/list';
import { MatSelect } from '@angular/material/select';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatTooltip } from '@angular/material/tooltip';
import { IconModule, ScrollbarModule } from '@michelin/theme';
import { ApplicationsService } from 'src/app/applications/applications.service';
import { Applications } from 'src/app/interfaces/application';
import { ConnectionDB } from 'src/app/interfaces/connectionDb';
import { Controller } from 'src/app/interfaces/controller';
import { ImportFileCsv } from 'src/app/interfaces/importFileCsv';
import { UtilService } from 'src/app/util/util.service';
import { ApplicationService } from '../application.service';

@Component({
  selector: 'mic-app-import-file-modal',
  templateUrl: './import-file-modal.component.html',
  styleUrls: ['./import-file-modal.component.scss'],
  imports: [
    MatSlideToggle,
    MatIcon,
    MatDivider,
    ReactiveFormsModule,
    CdkScrollable,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    MatSelect,
    ScrollbarModule,
    MatOption,
    MatCheckbox,
    MatTooltip,
    IconModule,
    MatDialogActions,
    MatButton
  ]
})
export class ImportFileModalComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ImportFileModalComponent>>(MatDialogRef);
  data = inject<ImportFileCsv>(MAT_DIALOG_DATA);
  private readonly applicationService = inject(ApplicationService);
  private readonly applicationsService = inject(ApplicationsService);
  private readonly utilService = inject(UtilService);
  private readonly cdr = inject(ChangeDetectorRef);

  signupForm: FormGroup;

  connectionDB: ConnectionDB[] = [];
  controllers: Controller[] = [];

  filterConfArray: FormGroup[] = [];

  columnIdsToRemove: number[] = [];

  changeFunction = false;
  application: Applications;
  ngOnInit(): void {
    this.preparColumns();
    this.connectionDB = this.applicationsService.myObject.connectionDBS;
    this.applicationService.getApplication().subscribe((response) => {
      this.application = response;
      this.connectionDB = response.connectionDBS;
      this.controllers = response.controllers;
      this.cdr.detectChanges();
    });

    if (this.data !== null) {
      this.utilService.convertImortFileCsvToImportFilceCreate(this.data);
    }

    this.signupForm = new FormGroup({
      name: new FormControl(this.data ? this.data.name : null, Validators.required),
      targetName: new FormControl(this.data ? this.data.targetName : null, Validators.required),
      connectionDBId: new FormControl(this.data ? this.data.connectionDB.id : null, Validators.required),
      header: new FormControl(this.data ? this.data.header : true),
      append: new FormControl(this.data ? this.data.append : true),
      autoIncrement: new FormControl(this.data ? this.data.autoIncrement : false),
      secondFunction: new FormControl(this.data ? this.data.secondFunction : false),
      delimiter: new FormControl(this.data ? this.data.delimiter : ';', Validators.required),
      columnCsvList: new FormArray(this.filterConfArray)
    });
  }

  private preparColumns(): void {
    if (this.data) {
      this.data.columnCsvList.forEach((column) => {
        const group = new FormGroup({
          id: new FormControl(column.id),
          name: new FormControl(column ? column.name : null, Validators.required),
          controllerId: new FormControl(column ? column.controller.id : null, Validators.required),
          nullable: new FormControl(column ? column.nullable : false)
        });
        this.filterConfArray.push(group);
      });
    } else {
      const group = new FormGroup({
        name: new FormControl(null, Validators.required),
        controllerId: new FormControl(null, Validators.required),
        nullable: new FormControl(true)
      });
      this.filterConfArray.push(group);
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  onClose(close: boolean): void {
    this.dialogRef.close(close);
  }

  onSubmit() {
    // add the configuration at the same time
    if (this.data) {
      const newData = { ...this.signupForm.value, columnsCsvIdsToRemove: this.columnIdsToRemove };
      // here i well create an endpoint that update the same function of the import file csv
      this.applicationService.updateFunctionImportFileCsv(this.data.id, newData).subscribe((result) => {
        this.dialogRef.close(result);
        this.cdr.detectChanges();
      });
    } else {
      // Here it's a new function that will be added
      this.applicationService.addFunctionImportFileCsv(this.signupForm.value).subscribe(() => {
        this.dialogRef.close(this.signupForm.value);
        this.cdr.detectChanges();
      });
    }
  }
  onAddColumn() {
    const group = new FormGroup({
      name: new FormControl(null, Validators.required),
      controllerId: new FormControl(null, Validators.required),
      nullable: new FormControl(true)
    });
    (this.signupForm.get('columnCsvList') as FormArray).push(group);
  }

  onDeleteColumn(i: number) {
    if ((this.signupForm.get('columnCsvList') as FormArray).at(i).value.id) {
      this.columnIdsToRemove.push((this.signupForm.get('columnCsvList') as FormArray).at(i).value.id);
    }
    (this.signupForm.get('columnCsvList') as FormArray).removeAt(i);
    (this.signupForm.get('columnCsvList') as FormArray).markAsDirty();
  }

  get controls() {
    return (this.signupForm.get('columnCsvList') as FormArray).controls;
  }

  checkboxChanged(event: MatCheckboxChange) {
    console.log(event);
  }
  onChangeFunction($event: any) {
    console.log('event : ', $event.checked);
    this.signupForm.get('secondFunction').setValue($event.checked);
  }
}
